import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-50 border-t border-primary-100">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-music-2-fill text-xl text-background-50"></i>
              </span>
              <span className="text-xl font-black tracking-tight text-foreground-950">抖音</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              抖音，记录美好生活。汇集音乐、搞笑、生活、美食等海量热门短视频，
              在这里发现灵感、分享快乐，让每一个精彩瞬间都被看见。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">
              <Link to="/" className="cursor-pointer hover:text-primary-600 transition-colors">站内导航</Link>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li><Link to="/" className="cursor-pointer hover:text-primary-600 transition-colors">首页</Link></li>
              <li><Link to="/search" className="cursor-pointer hover:text-primary-600 transition-colors">搜索</Link></li>
              <li><Link to="/about" className="cursor-pointer hover:text-primary-600 transition-colors">关于我们</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">
              <Link to="/category/music" className="cursor-pointer hover:text-primary-600 transition-colors">热门分类</Link>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              {categories.slice(0, 5).map((c) => (
                <li key={c.key}>
                  <Link to={`/category/${c.key}`} className="cursor-pointer hover:text-primary-600 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-primary-100 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 抖音短视频 · 本站为内容展示演示平台，视频均为演示数据</p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="cursor-pointer hover:text-primary-600 transition-colors">隐私政策</Link>
            <Link to="/about" className="cursor-pointer hover:text-primary-600 transition-colors">版权声明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}